import { render, staticRenderFns } from "./report-group.vue?vue&type=template&id=ee7d22e4&"
import script from "./report-group.vue?vue&type=script&lang=js&"
export * from "./report-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports